import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableHead } from '@mui/material';
import { currencyFormat, formatNumber } from '../../../utils/number';
import { dateFormat } from '../../../utils/date';
import GenericTablePaginationActions from '../../../component/generic/GenericTablePaginationActions';

// identificador é o número da comanda: é por ele que a loja confere o que foi cancelado
const columns = [
    { id: 'unidadeName', label: 'Unidade', minWidth: 80 },
    { id: 'identificador', label: 'Comanda', minWidth: 70, align: 'center' },
    { id: 'mesa', label: 'Mesa', minWidth: 60, align: 'center' },
    { id: 'produtoNome', label: 'Produto', minWidth: 200 },
    { id: 'quantidade', label: 'Quantidade', minWidth: 80 },
    { id: 'dataLancamento', label: 'Data Lançamento', minWidth: 50, align: 'center' },
    { id: 'dataExclusao', label: 'Data Cancelamento', minWidth: 50, align: 'center' },
    { id: 'nomeUsuarioLancamento', label: 'Usuário Lançamento', minWidth: 100, align: 'center' },
    { id: 'nomeUsuarioExclusao', label: 'Usuário Cancelamento', minWidth: 100, align: 'center' },
    { id: 'valorTotal', label: 'Valor Total', minWidth: 100, align: 'center' },
    { id: 'observacao', label: 'Observação', minWidth: 200, align: 'center' },
];

export default function ListChecking({ data }) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data?.length) : 0;

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TableContainer elevation={0} component={Paper}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {(rowsPerPage > 0
                        ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : data
                    ).map((row, index) => (
                        <TableRow key={index}>
                            <TableCell align="left">{row.unidadeName}</TableCell>
                            <TableCell align="center">{row.identificador || '---'}</TableCell>
                            <TableCell align="center">{row.mesa || '---'}</TableCell>
                            <TableCell align="left">{row.produtoNome}</TableCell>
                            <TableCell align="center">
                                {formatNumber(row.quantidade, { style: 'decimal', minimumFractionDigits: '3' })}
                            </TableCell>
                            <TableCell align="center">
                                {dateFormat(row.dataLancamento, { pattern: 'dd/MM/yyyy HH:mm:ss' })}
                            </TableCell>
                            <TableCell align="center">
                                {dateFormat(row.dataExclusao, { pattern: 'dd/MM/yyyy HH:mm:ss' })}
                            </TableCell>
                            <TableCell align='center'>{ row.nomeUsuarioLancamento !== null ? row.nomeUsuarioLancamento : "---"}</TableCell>
                            <TableCell align="center">{row.nomeUsuarioExclusao}</TableCell>
                            <TableCell align="center">
                                {currencyFormat(row.valorTotal, { simbol: '' })}
                            </TableCell>
                            <TableCell align="left">{row.observacao}</TableCell>
                        </TableRow>
                    ))}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={columns.length} />
                        </TableRow>
                    )}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, { label: 'Todos', value: -1 }]}
                            colSpan={columns.length}
                            count={data?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage="linhas por página"
                            SelectProps={{
                                inputProps: {
                                    'aria-label': 'linhas por página',
                                },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={GenericTablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
